import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import moment from 'moment';

@Component({
  name: 'bpc-display-field-time',
  components: {},
})
export default class DisplayFieldTime extends mixins(AbstractDisplayField) {
  get formatTime(): string {
    if (this.value) {
      return this.value.substr(0, 5);
    }
    return '';
  }
}
